import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import {
    TGetPendingDiscountListingReduxResponse,
    TGetPendingInventoryTransactionListingReduxResponse,
    TGetPendingTransactionListingReduxResponse,
    TPendingDiscountApprovalListingFilters,
    TPendingDiscountListing,
    TUpdateCollateralStatusReduxParams,
    TPendingProjectApprovalListingFilters,
    TPendingTransfersApprovalListingFilters,
    TUpdateDiscountStatusReduxParams,
    TUpdateInventoryTransactionStatusReduxParams,
    TUpdateProductStatusReduxParams,
    TUpdateProjectStatusReduxParams,
    TUpdateTransactionStatusReduxParams,
    TupdateTransferStatusReduxParams,
    TPendingReleaseEarmarkListingFilters,
    TUpdateReleaseEarmarkStatusReduxParams,
    TUpdateBranchesStatusReduxParams,
    TUpdateGoldConversionStatusReduxParams,
    TUpdateEarmarkConversionStatusReduxParams,
    TGetPendingStockOutListingReduxResponse,
    TUpdateStockOutStatusReduxParams,
    TGetPendingStockOutListingFilters,
    TGetPendingCustomerTransferListingReduxResponse,
    TUpdateCustomerTransferStatusReduxParams,
    TGetPendingCustomerTransferListingFilters,
} from '~types/feat/approval';
import { TGetBranchesChangeHistoryAPIResponse, TGetBranchListingFilters } from '~types/feat/branch';
import { TGetCollateralListingReduxResponse, TPendingCollateralApprovalListingFilters } from '~types/feat/customer';
import { TGetCustomerTransferListingFilters } from '~types/feat/customerTransfer';

import {
    TGetInventoryTransactionListingFilters,
    TGetPendingGoldConversionFiltersRedux,
    TGetTransactionListingFilters,
    TGoldConversionListingAPIResponse,
    TInventoryTransactionListing,
} from '~types/feat/gold';

import { TTransactionListing } from '~types/feat/gold';
import { TGetPendingInventoryTransferListingReduxResponse, TGetPendingProductListingReduxResponse, TGetPendingProjectListingReduxResponse, TGetReleaseEarmarkListingAPIResponse } from '~types/feat/setting';

import { TApprovalReduxState } from '~types/redux/state';

import { ApprovalTabsEnum, BranchApprovalStatusEnum, EarmarkReleaseRequestStatusEnum, GoldConversionStatusEnum, MetalTypeEnum, ProjectChangeHistoryStatusEnum, TransactionStatusEnum, TransferStatusEnum } from '~utils/enums';

const getFirstDayOfMonth = () => {
    const today = dayjs();

    const firstDay = today.startOf('month');

    return firstDay.toISOString();

};

const getTodaysDate = () => {
    const today = dayjs().endOf('day').toISOString();

    return today;
};

export const initialState: TApprovalReduxState = {
    loadings: {
        updateTransactionStatus: false,
        updateInventoryTransactionStatus: false,
        updateDiscountStatus: false,
        updateProductStatus: false,
        updateCollateralStatus: false,
        updateProjectStatus: false,
        updateTransferStatus: false,
        updateReleaseEarmarkStatus: false,
        updateBranchesStatus: false,
        updateGoldConversionStatus: false,
        updateEarmarkConversionStatus: false,
        updateStockOutStatus: false,
        updateCustomerTransferStatus: false,

        getPendingTransactionListing: false,
        getPendingInventoryTransactionListing: false,
        getPendingDiscountListing: false,
        getPendingProductListing: false,
        getPendingCollateralListing: false,
        getPendingProjectListing: false,
        getpendingTransferListing: false,
        getPendingReleaseEarmarkListing: false,
        getPendingBranchesListing: false,
        getPendingGoldConversionListing: false,
        getPendingStockOutListing: false,
        getPendingCustomerTransferListing: false,

    },
    selectedTab: ApprovalTabsEnum['Buy & Sell'],
    modals: {
        confirmUpdateTransactionStatusModalIsOpen: false,
        confirmUpdateInventoryTransactionStatusModalIsOpen: false,
        confirmUpdateDiscountStatusModalIsOpen: false,
        confirmUpdateProductStatusModalIsOpen: false,
        confirmUpdateCollateralStatusModalIsOpen: false,
        confirmUpdateProjectStatusModalIsOpen: false,
        confirmupdateTransferStatusModalIsOpen: false,
        confirmUpdateReleaseEarmarkModalIsOpen: false,
        confirmUpdateBranchesModalIsOpen: false,
        confirmUpdateGoldConversionModalIsOpen: false,
        confirmUpdateEarmarkConversionStatusModalIsOpen: false,
        confirmUpdateStockOutStatusModalIsOpen: false,
        confirmUpdateCustomerTransferStatusModalIsOpen: false,
    },
    tempUpdateTransactionState: {
        transactionId: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingTransactionListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            name: '',
            idNo: '',
            action: '',
            status: TransactionStatusEnum[TransactionStatusEnum.Pending],
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            branchName: '',
            metalType: '',
            branchCode: '',
            goldType: '',
            silverType: '',
        },
        data: [],
    },
    tempUpdateInventoryTransactionState: {
        inventoryLogId: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingInventoryTransactionListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            branchCode: '',
            branchName: '',
            productId: 0,
            productName: '',
            status: TransactionStatusEnum[TransactionStatusEnum.Pending],
            action: 'Restock',
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            metalType: '',
        },
        data: [],
    },
    tempUpdateDiscountState: {
        id: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingDiscountListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            discountCode: '',
            discountName: '',
            discountType: '',
            transactionType: '',
            status: '',
        },
        data: [],
    },
    tempUpdateProductState: {
        id: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingProductListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            productName: '',
            metalType: '',
        },
        data: [],
    },
    tempUpdateCollateralState: {
        id: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingCollateralListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            customerId: '',
            customerName: '',
            idNo: 0,
            branchName: '',
            branchCode: '',
            status: TransactionStatusEnum.Pending,
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            metalType: '',
            index: 0,
        },
        data: [],
    },
    tempUpdateProjectState: {
        id: 0,
        status: ProjectChangeHistoryStatusEnum.Pending,
    },
    pendingProjectListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            projectName: '',
            dateFrom: '',
            dateTo: '',
            status: '',
        },
        data: [],
    },
    tempUpdateTransferState: {
        id: 0,
        status: TransferStatusEnum.PendingDeliver,
    },
    pendingTransferListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            branchFrom: 0,
            branchTo: 0,
            branchName: '',
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            branchCode: '',
            metalType: '',
        },
        data: [],
    },
    tempUpdateReleaseEarmark: {
        id: 0,
        status: EarmarkReleaseRequestStatusEnum.Pending,
    },
    pendingReleaseEarmarkListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            branchName: '',
            branchCode: '',
            customerName: '',
            customerId: '',
            status: TransactionStatusEnum.Pending,
            metalType: '',
        },
        data: [],
    },
    pendingBranchesListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            regionName: '',
        },
        data: [],
    },
    tempUpdateBranchesState: {
        id: 0,
        status: BranchApprovalStatusEnum.Pending,
    },
    pendingGoldConversionListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            branchName: '',
            branchCode: '',
            productName: '',
            productId: 0,
            dateFrom: '',
            dateTo: '',
            metalType: '',
        },
        data: [],
    },
    tempUpdateGoldConversionState: {
        id: 0,
        status: GoldConversionStatusEnum.Pending,
    },
    tempUpdateEarmarkConversionState: {
        id: 0,
        status: 0,
    },
    tempUpdateStockOutState: {
        id: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingStockOutListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            serialNo: '',
            branchName: '',
            branchCode: '',
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            metalType: '',
        },
        data: [],
    },
    tempUpdateCustomerTransferState: {
        id: 0,
        status: TransactionStatusEnum.Pending,
    },
    pendingCustomerTransferListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            dateFrom: getFirstDayOfMonth(),
            dateTo: getTodaysDate(),
            branchName: '',
            branchCode: '',
            metalType: '',
            senderName: '',
            senderIdNo: '',
            receiverName: '',
            receiverIdNo: '',
            productName: '',
            productId: 0,
            status: '',
        },
        data: [],
    },
    errors: {
        updateTransactionStatus: '',
        updateInventoryTransactionStatus: '',
        updateDiscountStatus: '',
        updateProductStatus: '',
        updateCollateralStatus: '',
        updateProjectStatus: '',
        updateTransferStatus: '',
        updateReleaseEarmarkStatus: '',
        updateBranchesStatus: '',
        updateGoldConversionStatus: '',
        updateEarmarkConversionStatus: '',
        updateStockOutStatus: '',
        updateCustomerTransferStatus: '',

        getPendingTransactionListing: '',
        getPendingInventoryTransactionListing: '',
        getPendingDiscountListing: '',
        getPendingProductListing: '',
        getPendingCollateralListing: '',
        getPendingProjectListing: '',
        getpendingTransferListing: '',
        getPendingReleaseEarmarkListing: '',
        getPendingBranchesListing: '',
        getPendingGoldConversionListing: '',
        getPendingStockOutListing: '',
        getPendingCustomerTransferListing: '',
    },
};

const approvalSlice = createSlice({
    name: 'approval',
    initialState,
    reducers: {
        approvalSetSelectedTab: (state, action: PayloadAction<ApprovalTabsEnum>) => {
            state.selectedTab = action.payload;
        },
        approvalSetPendingTransactionListingFilters: (state, action: PayloadAction<TGetTransactionListingFilters>) => {
            state.pendingTransactionListing.filters = action.payload;
        },
        approvalSetPendingTransactionListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingTransactionListing.index = action.payload.index;
        },
        approvalSetPendingTransactionListingData: (state, action: PayloadAction<TTransactionListing[]>) => {
            state.pendingTransactionListing.data = action.payload;
        },
        approvalGetPendingTransactionListingAttempt: (state) => {
            state.loadings.getPendingTransactionListing = true;
            state.errors.getPendingTransactionListing = '';
        },
        approvalGetPendingTransactionListingSuccess: (state, action: PayloadAction<TGetPendingTransactionListingReduxResponse>) => {
            state.loadings.getPendingTransactionListing = false;
            state.pendingTransactionListing = {
                filters: state.pendingTransactionListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingTransactionListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingTransactionListing = false;
            if (action.payload) state.errors.getPendingTransactionListing = action.payload;
        },
        approvalUpdateTransactionStatusAttempt: (state, _action: PayloadAction<TUpdateTransactionStatusReduxParams>) => {
            state.loadings.updateTransactionStatus = true;
            state.errors.updateTransactionStatus = '';
        },
        approvalUpdateTransactionStatusSuccess: (state) => {
            state.loadings.updateTransactionStatus = false;
        },
        approvalUpdateTransactionStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateTransactionStatus = false;
            if (action.payload) state.errors.updateTransactionStatus = action.payload;
        },
        approvalResetUpdateTransactionStatusState: (state) => {
            state.loadings.updateTransactionStatus = initialState.loadings.updateTransactionStatus;
            state.errors.updateTransactionStatus = initialState.errors.updateTransactionStatus;
        },
        approvalSetConfirmUpdateTransactionStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateTransactionStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateTransactionState: (state, action: PayloadAction<TUpdateTransactionStatusReduxParams>) => {
            state.tempUpdateTransactionState = action.payload;
        },
        approvalSetPendingInventoryTransactionListingFilters: (state, action: PayloadAction<TGetInventoryTransactionListingFilters>) => {
            state.pendingInventoryTransactionListing.filters = action.payload;
        },
        approvalSetPendingInventoryTransactionListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingInventoryTransactionListing.index = action.payload.index;
        },
        approvalSetPendingInventoryTransactionListingData: (state, action: PayloadAction<TInventoryTransactionListing[]>) => {
            state.pendingInventoryTransactionListing.data = action.payload;
        },
        approvalGetPendingInventoryTransactionListingAttempt: (state) => {
            state.loadings.getPendingInventoryTransactionListing = true;
            state.errors.getPendingInventoryTransactionListing = '';
        },
        approvalGetPendingInventoryTransactionListingSuccess: (state, action: PayloadAction<TGetPendingInventoryTransactionListingReduxResponse>) => {
            state.loadings.getPendingInventoryTransactionListing = false;
            state.pendingInventoryTransactionListing = {
                filters: state.pendingInventoryTransactionListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingInventoryTransactionListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingInventoryTransactionListing = false;
            if (action.payload) state.errors.getPendingInventoryTransactionListing = action.payload;
        },
        approvalUpdateInventoryTransactionStatusAttempt: (state, _action: PayloadAction<TUpdateInventoryTransactionStatusReduxParams>) => {
            state.loadings.updateInventoryTransactionStatus = true;
            state.errors.updateInventoryTransactionStatus = '';
        },
        approvalUpdateInventoryTransactionStatusSuccess: (state) => {
            state.loadings.updateInventoryTransactionStatus = false;
        },

        approvalUpdateInventoryTransactionStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateInventoryTransactionStatus = false;
            if (action.payload) state.errors.updateInventoryTransactionStatus = action.payload;
        },
        approvalSetConfirmUpdateInventoryTransactionStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateInventoryTransactionStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateInventoryTransactionState: (state, action: PayloadAction<TUpdateInventoryTransactionStatusReduxParams>) => {
            state.tempUpdateInventoryTransactionState = action.payload;
        },
        approvalResetUpdateInventoryTransactionStatusState: (state) => {
            state.loadings.updateInventoryTransactionStatus = initialState.loadings.updateTransactionStatus;
            state.errors.updateInventoryTransactionStatus = initialState.errors.updateTransactionStatus;
        },

        approvalSetPendingDiscountListingFilters: (state, action: PayloadAction<TPendingDiscountApprovalListingFilters>) => {
            state.pendingDiscountListing.filters = action.payload;
        },
        approvalSetPendingDiscountListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingDiscountListing.index = action.payload.index;
        },
        approvalSetPendingDiscountListingData: (state, action: PayloadAction<TPendingDiscountListing[]>) => {
            state.pendingDiscountListing.data = action.payload;
        },
        approvalGetPendingDiscountListingAttempt: (state) => {
            state.loadings.getPendingDiscountListing = true;
            state.errors.getPendingDiscountListing = '';
        },
        approvalGetPendingDiscountListingSuccess: (state, action: PayloadAction<TGetPendingDiscountListingReduxResponse>) => {
            state.loadings.getPendingDiscountListing = false;
            state.pendingDiscountListing = {
                filters: state.pendingDiscountListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingDiscountListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingDiscountListing = false;
            if (action.payload) state.errors.getPendingDiscountListing = action.payload;
        },
        approvalUpdateDiscountStatusAttempt: (state, _action: PayloadAction<TUpdateDiscountStatusReduxParams>) => {
            state.loadings.updateDiscountStatus = true;
            state.errors.updateDiscountStatus = '';
        },
        approvalUpdateDiscountStatusSuccess: (state) => {
            state.loadings.updateDiscountStatus = false;
        },
        approvalUpdateDiscountStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateDiscountStatus = false;
            if (action.payload) state.errors.updateDiscountStatus = action.payload;
        },
        approvalSetConfirmUpdateDiscountStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateDiscountStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateDiscountState: (state, action: PayloadAction<TUpdateDiscountStatusReduxParams>) => {
            state.tempUpdateDiscountState = action.payload;
        },
        approvalResetUpdateDiscountStatusState: (state) => {
            state.loadings.updateDiscountStatus = initialState.loadings.updateDiscountStatus;
            state.errors.updateDiscountStatus = initialState.errors.updateDiscountStatus;
        },
        approvalSetPendingProductListingFilters: (state, action: PayloadAction<{ productName: string, metalType: string }>) => {
            state.pendingProductListing.filters = action.payload;
        },
        approvalClearPendingProductListingFilters: (state) => {
            state.pendingProductListing.filters = initialState.pendingProductListing.filters;
        },
        approvalGetPendingProductListingAttempt: (state) => {
            state.loadings.getPendingProductListing = true;
            state.errors.getPendingProductListing = '';
        },
        approvalGetPendingProductListingSuccess: (state, action: PayloadAction<TGetPendingProductListingReduxResponse>) => {
            state.loadings.getPendingProductListing = false;
            state.pendingProductListing = {
                filters: state.pendingProductListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingProductListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingProductListing = false;
            if (action.payload) state.errors.getPendingProductListing = action.payload;
        },
        approvalUpdateProductStatusAttempt: (state, _action: PayloadAction<TUpdateProductStatusReduxParams>) => {
            state.loadings.updateProductStatus = true;
            state.errors.updateProductStatus = '';
        },
        approvalUpdateProductStatusSuccess: (state) => {
            state.loadings.updateProductStatus = false;
        },
        approvalUpdateProductStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateProductStatus = false;
            if (action.payload) state.errors.updateProductStatus = action.payload;
        },
        approvalSetConfirmUpdateProductStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateProductStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateProductState: (state, action: PayloadAction<TUpdateProductStatusReduxParams>) => {
            state.tempUpdateProductState = action.payload;
        },
        approvalResetUpdateProductStatusState: (state) => {
            state.loadings.updateProductStatus = initialState.loadings.updateProductStatus;
            state.errors.updateProductStatus = initialState.errors.updateProductStatus;
        },
        approvalSetPendingProductListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingProductListing.index = action.payload.index;
        },
        approvalSetPendingCollateralListingFilters: (state, action: PayloadAction<TPendingCollateralApprovalListingFilters>) => {
            state.pendingCollateralListing.filters = action.payload;
        },
        approvalClearPendingCollateralListingFilters: (state) => {
            state.pendingCollateralListing.filters = initialState.pendingCollateralListing.filters;
        },
        approvalSetConfirmUpdateCollateralStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateCollateralStatusModalIsOpen = action.payload;
        },
        approvalUpdateCollateralStatusAttempt: (state, _action: PayloadAction<TUpdateCollateralStatusReduxParams>) => {
            state.loadings.updateCollateralStatus = true;
            state.errors.updateCollateralStatus = '';
        },
        approvalUpdateCollateralStatusSuccess: (state) => {
            state.loadings.updateCollateralStatus = false;
        },
        approvalUpdateCollateralStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateCollateralStatus = false;
            if (action.payload) state.errors.updateCollateralStatus = action.payload;
        },
        approvalSetTempUpdateCollateralState: (state, action: PayloadAction<TUpdateCollateralStatusReduxParams>) => {
            state.tempUpdateCollateralState = action.payload;
        },

        approvalResetUpdateCollateralStatusState: (state) => {
            state.loadings.updateCollateralStatus = initialState.loadings.updateCollateralStatus;
            state.errors.updateCollateralStatus = initialState.errors.updateCollateralStatus;
        },
        approvalSetPendingCollateralListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingCollateralListing.index = action.payload.index;
        },
        approvalGetPendingCollateralListingAttempt: (state) => {
            state.loadings.getPendingCollateralListing = true;
            state.errors.getPendingCollateralListing = '';
        },
        approvalGetPendingCollateralListingSuccess: (state, action: PayloadAction<TGetCollateralListingReduxResponse>) => {
            state.loadings.getPendingCollateralListing = false;
            state.pendingCollateralListing = {
                filters: state.pendingCollateralListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingCollateralListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingCollateralListing = false;
            if (action.payload) state.errors.getPendingCollateralListing = action.payload;
        },
        approvalSetPendingProjectListingFilters: (state, action: PayloadAction<TPendingProjectApprovalListingFilters>) => {
            state.pendingProjectListing.filters = action.payload;
        },
        approvalClearPendingProjectListingFilters: (state) => {
            state.pendingProjectListing.filters = initialState.pendingProjectListing.filters;
        },
        approvalGetPendingProjectListingAttempt: (state) => {
            state.loadings.getPendingProjectListing = true;
            state.errors.getPendingProjectListing = '';
        },
        approvalGetPendingProjectListingSuccess: (state, action: PayloadAction<TGetPendingProjectListingReduxResponse>) => {
            state.loadings.getPendingProjectListing = false;
            state.pendingProjectListing = {
                filters: state.pendingProjectListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingProjectListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingProjectListing = false;
            if (action.payload) state.errors.getPendingProjectListing = action.payload;
        },
        approvalUpdateProjectStatusAttempt: (state, _action: PayloadAction<TUpdateProjectStatusReduxParams>) => {
            state.loadings.updateProjectStatus = true;
            state.errors.updateProjectStatus = '';
        },
        approvalUpdateProjectStatusSuccess: (state) => {
            state.loadings.updateProjectStatus = false;
        },
        approvalUpdateProjectStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateProjectStatus = false;
            if (action.payload) state.errors.updateProjectStatus = action.payload;
        },
        approvalSetConfirmUpdateProjectStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateProjectStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateProjectState: (state, action: PayloadAction<TUpdateProjectStatusReduxParams>) => {
            state.tempUpdateProjectState = action.payload;
        },
        approvalResetUpdateProjectStatusState: (state) => {
            state.loadings.updateProjectStatus = initialState.loadings.updateProjectStatus;
            state.errors.updateProjectStatus = initialState.errors.updateProjectStatus;
        },
        approvalSetPendingProjectListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingProjectListing.index = action.payload.index;
        },
        approvalSetpendingTransferListingFilters: (state, action: PayloadAction<TPendingTransfersApprovalListingFilters>) => {
            state.pendingTransferListing.filters = action.payload;
        },
        approvalClearpendingTransferListingFilters: (state) => {
            state.pendingTransferListing.filters = initialState.pendingTransferListing.filters;
        },
        approvalGetPendingTransferListingAttempt: (state) => {
            state.loadings.getpendingTransferListing = true;
            state.errors.getpendingTransferListing = '';
        },
        approvalGetpendingTransferListingSuccess: (state, action: PayloadAction<TGetPendingInventoryTransferListingReduxResponse>) => {
            state.loadings.getpendingTransferListing = false;
            state.pendingTransferListing = {
                filters: state.pendingTransferListing.filters,
                ...action.payload,
            };
        },
        approvalGetpendingTransferListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getpendingTransferListing = false;
            if (action.payload) state.errors.getpendingTransferListing = action.payload;
        },
        approvalupdateTransferStatusAttempt: (state, _action: PayloadAction<TupdateTransferStatusReduxParams>) => {
            state.loadings.updateTransferStatus = true;
            state.errors.updateTransferStatus = '';
        },
        approvalupdateTransferStatusSuccess: (state) => {
            state.loadings.updateTransferStatus = false;
        },
        approvalupdateTransferStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateTransferStatus = false;
            if (action.payload) state.errors.updateTransferStatus = action.payload;
        },
        approvalSetConfirmupdateTransferStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmupdateTransferStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateTransferState: (state, action: PayloadAction<TupdateTransferStatusReduxParams>) => {
            state.tempUpdateTransferState = action.payload;
        },
        approvalResetupdateTransferStatusState: (state) => {
            state.loadings.updateTransferStatus = initialState.loadings.updateTransferStatus;
            state.errors.updateTransferStatus = initialState.errors.updateTransferStatus;
        },
        approvalSetpendingTransferListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingTransferListing.index = action.payload.index;
        },
        approvalSetPendingReleaseEarmarkListingFilters: (state, action: PayloadAction<TPendingReleaseEarmarkListingFilters>) => {
            state.pendingReleaseEarmarkListing.filters = action.payload;
        },
        approvalClearPendingReleaseEarmarkListingFilters: (state) => {
            state.pendingReleaseEarmarkListing.filters = initialState.pendingReleaseEarmarkListing.filters;
        },
        approvalGetPendingReleaseEarmarkListingAttempt: (state) => {
            state.loadings.getPendingReleaseEarmarkListing = true;
            state.errors.getPendingReleaseEarmarkListing = '';
        },
        approvalGetPendingReleaseEarmarkListingSuccess: (state, action: PayloadAction<TGetReleaseEarmarkListingAPIResponse>) => {
            state.loadings.getPendingReleaseEarmarkListing = false;
            state.pendingReleaseEarmarkListing = {
                filters: state.pendingReleaseEarmarkListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingReleaseEarmarkListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingReleaseEarmarkListing = false;
            if (action.payload) state.errors.getPendingReleaseEarmarkListing = action.payload;
        },
        approvalUpdateReleaseEarmarkStatusAttempt: (state, _action: PayloadAction<TUpdateReleaseEarmarkStatusReduxParams>) => {
            state.loadings.updateReleaseEarmarkStatus = true;
            state.errors.updateReleaseEarmarkStatus = '';
        },
        approvalUpdateReleaseEarmarkStatusSuccess: (state) => {
            state.loadings.updateReleaseEarmarkStatus = false;
        },
        approvalUpdateReleaseEarmarkStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateReleaseEarmarkStatus = false;
            if (action.payload) state.errors.updateReleaseEarmarkStatus = action.payload;
        },
        approvalSetConfirmUpdateReleaseEarmarkStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateReleaseEarmarkModalIsOpen = action.payload;
        },
        approvalSetTempUpdateReleaseEarmarkState: (state, action: PayloadAction<TUpdateReleaseEarmarkStatusReduxParams>) => {
            state.tempUpdateReleaseEarmark = action.payload;
        },
        approvalResetUpdateReleaseEarmarkStatusState: (state) => {
            state.loadings.updateReleaseEarmarkStatus = initialState.loadings.updateReleaseEarmarkStatus;
            state.errors.updateReleaseEarmarkStatus = initialState.errors.updateReleaseEarmarkStatus;
        },
        approvalSetPendingReleaseEarmarkListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingReleaseEarmarkListing.index = action.payload.index;
        },
        approvalSetBranchesListingFilters: (state, action: PayloadAction<TGetBranchListingFilters>) => {
            state.pendingBranchesListing.filters = action.payload;
        },
        approvalClearPendingBranchesListingFilters: (state) => {
            state.pendingBranchesListing.filters = initialState.pendingBranchesListing.filters;
        },
        approvalGetPendingBranchesListingAttempt: (state) => {
            state.loadings.getPendingBranchesListing = true;
            state.errors.getPendingBranchesListing = '';
        },
        approvalGetPendingBranchesListingSuccess: (state, action: PayloadAction<TGetBranchesChangeHistoryAPIResponse>) => {
            state.loadings.getPendingBranchesListing = false;
            state.pendingBranchesListing = {
                filters: state.pendingBranchesListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingBranchesListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingBranchesListing = false;
            if (action.payload) state.errors.getPendingBranchesListing = action.payload;
        },
        approvalUpdateBranchesStatusAttempt: (state, _action: PayloadAction<TUpdateBranchesStatusReduxParams>) => {
            state.loadings.updateBranchesStatus = true;
            state.errors.updateBranchesStatus = '';
        },
        approvalUpdateBranchesStatusSuccess: (state) => {
            state.loadings.updateBranchesStatus = false;
        },
        approvalUpdateBranchesStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateBranchesStatus = false;
            if (action.payload) state.errors.updateBranchesStatus = action.payload;
        },
        approvalSetConfirmUpdateBranchesStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateBranchesModalIsOpen = action.payload;
        },
        approvalSetTempUpdateBranchesState: (state, action: PayloadAction<TUpdateBranchesStatusReduxParams>) => {
            state.tempUpdateBranchesState = action.payload;
        },
        approvalResetUpdateBranchesStatusState: (state) => {
            state.loadings.updateBranchesStatus = initialState.loadings.updateBranchesStatus;
            state.errors.updateBranchesStatus = initialState.errors.updateBranchesStatus;
        },
        approvalSetPendingBranchesListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingBranchesListing.index = action.payload.index;
        },
        approvalGetPendingGoldConversionListingAttempt: (state) => {
            state.loadings.getPendingGoldConversionListing = true;
            state.errors.getPendingGoldConversionListing = '';
        },
        approvalGetPendingGoldConversionListingSuccess: (state, action: PayloadAction<TGoldConversionListingAPIResponse>) => {
            state.loadings.getPendingGoldConversionListing = false;
            state.pendingGoldConversionListing = {
                filters: state.pendingGoldConversionListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingGoldConversionListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingGoldConversionListing = false;
            if (action.payload) state.errors.getPendingGoldConversionListing = action.payload;
        },
        approvalSetPendingGoldConversionListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingGoldConversionListing.index = action.payload.index;
        },
        approvalSetGoldConversionListingFilters: (state, action: PayloadAction<TGetPendingGoldConversionFiltersRedux>) => {
            state.pendingGoldConversionListing.filters = action.payload;
        },
        approvalClearPendingGoldConversionListingFilters: (state) => {
            state.pendingGoldConversionListing.filters = initialState.pendingGoldConversionListing.filters;
        },
        approvalSetTempUpdateGoldConversionState: (state, action: PayloadAction<TUpdateGoldConversionStatusReduxParams>) => {
            state.tempUpdateGoldConversionState = action.payload;
        },
        approvalResetUpdateGoldConversionStatusState: (state) => {
            state.loadings.updateGoldConversionStatus = initialState.loadings.updateGoldConversionStatus;
            state.errors.updateGoldConversionStatus = initialState.errors.updateGoldConversionStatus;
        },
        approvalSetConfirmUpdateGoldConversionStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateGoldConversionModalIsOpen = action.payload;
        },
        approvalUpdateGoldConversionStatusAttempt: (state, _action: PayloadAction<TUpdateGoldConversionStatusReduxParams>) => {
            state.loadings.updateGoldConversionStatus = true;
            state.errors.updateGoldConversionStatus = '';
        },
        approvalUpdateGoldConversionStatusSuccess: (state) => {
            state.loadings.updateGoldConversionStatus = false;
        },
        approvalUpdateGoldConversionStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateGoldConversionStatus = false;
            if (action.payload) state.errors.updateGoldConversionStatus = action.payload;
        },
        approvalUpdateEarmarkConversionStatusAttempt: (state, _action: PayloadAction<TUpdateEarmarkConversionStatusReduxParams>) => {
            state.loadings.updateEarmarkConversionStatus = true;
            state.errors.updateEarmarkConversionStatus = '';
        },
        approvalUpdateEarmarkConversionStatusSuccess: (state) => {
            state.loadings.updateEarmarkConversionStatus = false;
            state.errors.updateEarmarkConversionStatus = '';
        },
        approvalUpdateEarmarkConversionStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateEarmarkConversionStatus = false;
            if (action.payload) state.errors.updateEarmarkConversionStatus = action.payload;
        },
        approvalSetConfirmUpdateEarmarkConversionStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateEarmarkConversionStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateEarmarkConversionState: (state, action: PayloadAction<TUpdateEarmarkConversionStatusReduxParams>) => {
            state.tempUpdateEarmarkConversionState = action.payload;
        },
        approvalResetUpdateEarmarkConversionStatusState: (state) => {
            state.loadings.updateEarmarkConversionStatus = initialState.loadings.updateEarmarkConversionStatus;
            state.errors.updateEarmarkConversionStatus = initialState.errors.updateEarmarkConversionStatus;
        },
        approvalGetPendingStockOutListingAttempt: (state) => {
            state.loadings.getPendingStockOutListing = true;
            state.errors.getPendingStockOutListing = '';
        },
        approvalGetPendingStockOutListingSuccess: (state, action: PayloadAction<TGetPendingStockOutListingReduxResponse>) => {
            state.loadings.getPendingStockOutListing = false;
            state.pendingStockOutListing = {
                filters: state.pendingStockOutListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingStockOutListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingStockOutListing = false;
            if (action.payload) state.errors.getPendingStockOutListing = action.payload;
        },
        approvalUpdateStockOutStatusAttempt: (state, _action: PayloadAction<TUpdateStockOutStatusReduxParams>) => {
            state.loadings.updateStockOutStatus = true;
            state.errors.updateStockOutStatus = '';
        },
        approvalUpdateStockOutStatusSuccess: (state) => {
            state.loadings.updateStockOutStatus = false;
            state.errors.updateStockOutStatus = '';
        },
        approvalUpdateStockOutStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateStockOutStatus = false;
            if (action.payload) state.errors.updateStockOutStatus = action.payload;
        },
        approvalSetConfirmUpdateStockOutStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateStockOutStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateStockOutState: (state, action: PayloadAction<TUpdateStockOutStatusReduxParams>) => {
            state.tempUpdateStockOutState = action.payload;
        },
        approvalResetUpdateStockOutStatusState: (state) => {
            state.loadings.updateStockOutStatus = initialState.loadings.updateStockOutStatus;
            state.errors.updateStockOutStatus = initialState.errors.updateStockOutStatus;
        },
        approvalSetPendingStockOutListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingStockOutListing.index = action.payload.index;
        },
        approvalSetPendingStockOutListingFilters: (state, action: PayloadAction<TGetPendingStockOutListingFilters>) => {
            state.pendingStockOutListing.filters = action.payload;
        },
        approvalClearPendingStockOutListingFilters: (state) => {
            state.pendingStockOutListing.filters = initialState.pendingStockOutListing.filters;
        },

        approvalGetPendingCustomerTransferListingAttempt: (state) => {
            state.loadings.getPendingCustomerTransferListing = true;
            state.errors.getPendingCustomerTransferListing = '';
        },
        approvalGetPendingCustomerTransferListingSuccess: (state, action: PayloadAction<TGetPendingCustomerTransferListingReduxResponse>) => {
            state.loadings.getPendingCustomerTransferListing = false;
            state.pendingCustomerTransferListing = {
                filters: state.pendingCustomerTransferListing.filters,
                ...action.payload,
            };
        },
        approvalGetPendingCustomerTransferListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getPendingCustomerTransferListing = false;
            if (action.payload) state.errors.getPendingCustomerTransferListing = action.payload;
        },
        approvalUpdateCustomerTransferStatusAttempt: (state, _action: PayloadAction<TUpdateCustomerTransferStatusReduxParams>) => {
            state.loadings.updateCustomerTransferStatus = true;
            state.errors.updateCustomerTransferStatus = '';
        },
        approvalUpdateCustomerTransferStatusSuccess: (state) => {
            state.loadings.updateCustomerTransferStatus = false;
            state.errors.updateCustomerTransferStatus = '';
        },
        approvalUpdateCustomerTransferStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.updateCustomerTransferStatus = false;
            if (action.payload) state.errors.updateCustomerTransferStatus = action.payload;
        },
        approvalSetConfirmUpdateCustomerTransferStatusModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.confirmUpdateCustomerTransferStatusModalIsOpen = action.payload;
        },
        approvalSetTempUpdateCustomerTransferState: (state, action: PayloadAction<TUpdateCustomerTransferStatusReduxParams>) => {
            state.tempUpdateCustomerTransferState = action.payload;
        },
        approvalResetUpdateCustomerTransferStatusState: (state) => {
            state.loadings.updateCustomerTransferStatus = initialState.loadings.updateCustomerTransferStatus;
            state.errors.updateCustomerTransferStatus = initialState.errors.updateCustomerTransferStatus;
        },
        approvalSetPendingCustomerTransferListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.pendingCustomerTransferListing.index = action.payload.index;
        },
        approvalSetPendingCustomerTransferListingFilters: (state, action: PayloadAction<TGetCustomerTransferListingFilters>) => {
            state.pendingCustomerTransferListing.filters = action.payload;
        },
        approvalClearPendingCustomerTransferListingFilters: (state) => {
            state.pendingCustomerTransferListing.filters = initialState.pendingCustomerTransferListing.filters;
        },
    },
});

export default {
    actions: approvalSlice.actions,
    reducers: approvalSlice.reducer,
};
